import _ from 'lodash'
import Vuex from 'vuex'

import Project from '@/models/project'

export default {

    computed: {
        ...Vuex.mapState({
            /**
             * @param {VuexState} stateStore
             * @returns {Project}
             */
            currentProject: stateStore => Project.ensure(stateStore.improvements.currentProject),

            /**
             * @param {VuexState} stateStore
             * @returns {ImprovementsVuexStateFilters}
             */
            improvementFilters: stateStore => stateStore.improvements.improvementFilters,

            /**
             * @param {VuexState} stateStore
             * @returns {Array<ImprovementsVuexStateVisibleSegment>}
             */
            visibleSegments: stateStore => stateStore.improvements.visibleSegments,

            /**
             * @param {VuexState} stateStore
             * @returns {Array<number>}
             */
            notAppliedImprovements: stateStore => stateStore.metrics.notAppliedImprovements,
        }),

        filteredImprovements() {
            return this.primaryFilteredImprovements
                .filter(imp => _.includes(this.visibleSegmentKeys, imp.segmentKey))
        },

        primaryFilteredImprovements() {
            if (this.improvementFilters.recommended && this.improvementFilters.selected) {
                return this.currentProject.addedOrRecommendedImprovements
                    .filter(imp => imp.accepted && imp.recommended)
            }
            if (this.improvementFilters.recommended)
                return this.currentProject.recommendedImprovements
            else if (this.improvementFilters.selected)
                return this.currentProject.addedImprovements

            return this.currentProject.availableImprovements
        },

        visibleSegmentKeys() {
            return this.visibleSegments.filter(seg => seg.visible).map(seg => seg.key)
        },
    },
}
